import { CurrencyPipe } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { map, take } from 'rxjs';
import { Order } from 'src/app/common/Order';
import { OrderService } from 'src/app/services/order.service';
import { faInfoCircle, faFilePdf } from '@fortawesome/free-solid-svg-icons';
import { OrderClaimFilter } from 'src/app/common/OrderClaimFilter';
import { OrderPositionStatusConstants } from 'src/app/common/OrderPositionStatus';
import { AppProfileService } from 'src/app/services/profile.service';
import { Router } from '@angular/router';
import { ExtendedProfile } from 'src/app/common/ExtendedProfile';
import { KENDO_GRID } from '@progress/kendo-angular-grid';
import { PagedList } from 'src/app/common/PagedList';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { OrderClaimSearchComponent } from '../order-claim-search/order-claim-search.component';
import { GridPdfColumnsDirective } from '../grid/grid-pdf-columns.directive';
import { PdfPageComponent } from '../grid/pdf-page.component';
import { GridNoRecordsComponent } from '../grid/grid-no-records.component';

@Component({
    imports: [CurrencyPipe, KENDO_GRID, FontAwesomeModule, OrderClaimSearchComponent, GridPdfColumnsDirective, PdfPageComponent, GridNoRecordsComponent],
    selector: 'app-order-claim-list',
    templateUrl: './order-claim-list.component.html',
    styleUrls: ['./order-claim-list.component.css']
})
export class OrderClaimListComponent implements OnInit {
  orderService = inject(OrderService);
  private router = inject(Router);
  private profileService = inject(AppProfileService);

  // Set by <app-order-claim-search>, which emits its default criteria on init — that is the
  // first load (ngOnInit used to start a second one alongside it).
  filter: OrderClaimFilter;
  faInfoCircle = faInfoCircle;
  faFilePdf = faFilePdf;
  public showApproveReject: boolean = false;
  private isRetailer: boolean = false;
  public profile: ExtendedProfile = null;

  // #648: server-side paging/sorting; default order = newest first.
  public list = new PagedList<Order>({
    sortFields: { orderDateTime: 'orderDateTime' },
    defaultSort: [{ field: 'orderDateTime', dir: 'desc' }],
    fetch: (paging) =>
      this.filter
        ? this.orderService
            .getSaleOrdersByFilter(this.filter.dateFrom, this.filter.dateTo, null, this.states(), paging)
            .pipe(
              map((r) => {
                r.items.forEach((o) => (o.orderDateTime = new Date(o.orderDateTime)));
                return r;
              })
            )
        : null,
  });

  ngOnInit() {
    this.profileService.currentProfile$.pipe(take(1)).subscribe((profile) => {
      this.profile = profile;
      this.isRetailer = profile.customer.isRetailer;
      this.showApproveReject = this.isRetailer;
    });
  }

  search(filter: OrderClaimFilter) {
    this.filter = filter;
    this.list.search();
  }

  private states(): string[] {
    const states: string[] = [];
    if (this.filter.cancellationPending) {
      states.push(OrderPositionStatusConstants.PositionStatusIdCancellationPending);
    }
    if (this.filter.cancelled) {
      states.push(OrderPositionStatusConstants.PositionStatusIdCancelled);
    }
    return states;
  }

  public onDetails(order: Order) {
    if(this.isRetailer){
      this.router.navigate(['/shop-order-seller-edit/' + order],
      { queryParams: { showApproveCancellationButton: this.showApproveReject, showRejectCancellationButton: this.showApproveReject } });
    }
    else{
      this.router.navigate(['/shop-order-buyer-edit/' + order],
      { queryParams: { showApproveCancellationButton: this.showApproveReject, showRejectCancellationButton: this.showApproveReject } });
    }

  }
}
